import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import './blog-detail.scss';

const timingsData = [
  {
    id: 1,
    title: 'Kutup Muhurat (Most Auspicious)',
    time: '11:36 AM - 12:25 PM',
    highlight: true,
    timeColor: 'gold',
  },
  {
    id: 2,
    title: 'Rohina Muhurat',
    time: '12:25 PM - 01:14 PM',
    highlight: false,
    timeColor: 'teal',
  },
  {
    id: 3,
    title: 'Aparahna Kaal (Main Shradh Time)',
    time: '01:14 PM - 03:38 PM',
    highlight: true,
    timeColor: 'gold',
  },
  {
    id: 4,
    title: 'Morning Tarpan Time',
    time: '06:15 AM - 09:30 AM',
    highlight: false,
    timeColor: 'teal',
  },
  {
    id: 5,
    title: 'Sarva Pitru Amavasya',
    time: 'Shradh Purnahuti Day',
    highlight: false,
    timeColor: 'dark',
  },
];

const dossierData = [
  { key: 'Sacred Occasion', val: 'Pitru Paksha (Shradh Mahapaksha)' },
  { key: 'Lunar Duration', val: 'Bhadrapada Purnima to Sarva Pitru Amavasya (16 Days)' },
  { key: 'Presiding Deities', val: 'Pitru Devatas, Lord Yama & Lord Vishnu' },
  { key: 'Sacred Materials', val: 'Kusha Grass, Black Sesame (Til), Raw Cow Milk, Ganga Jal, Copper Vessel' },
  { key: 'Panchbali Offerings', val: 'Cow (Go), Dog (Shwan), Crow (Kaka), Deities & Ants (Pipilika)' },
  { key: 'Supreme Donations', val: 'Cow, Land, Sesame, Gold, Ghee, Clothes, Grains, Jaggery, Silver, Salt' },
  { key: 'Primary Direction', val: 'South Direction (Dakshina Disha)' },
];

const panchbaliList = [
  {
    id: 1,
    name: '1. Kaka Bali (The Crow)',
    tag: 'Messengers of Yama & blessed by Lord Rama to deliver food to ancestors',
    image: '/assets/blog/pitru-paksha-crow-banner.jpg',
  },
  {
    id: 2,
    name: '2. Go Bali (The Cow)',
    tag: 'Abode of all deities, helps departed souls cross the sacred Vaitarni river',
    image: '/assets/blog/categories/deities-devotion.png',
  },
  {
    id: 3,
    name: '3. Shwan Bali (The Dog)',
    tag: 'Faithful companions and guardians of Lord Yama across all realms',
    image: '/assets/blog/categories/mythology-legends.png',
  },
  {
    id: 4,
    name: '4. Deva Bali (Divine Deities)',
    tag: 'Honoring elemental energies, Viswadevas and cosmic balance',
    image: '/assets/blog/categories/festivals-rituals.png',
  },
  {
    id: 5,
    name: '5. Pipilika Bali (The Ants)',
    tag: 'Feeding minute creatures of the earth for universal soul satisfaction',
    image: '/assets/blog/categories/hidden-mysteries.png',
  },
];

const interestedBlogs = [
  {
    id: 1,
    title: 'केदारनाथ मंदिर: जहाँ धरती में समा गए थे भगवान शिव!',
    image: '/assets/blog/trending/kedarnath.webp',
    link: '/blog/kedarnath-temple-history-and-pandava-story',
  },
  {
    id: 2,
    title: 'Why is Ganesh Chaturthi celebrated? Rituals & History',
    image: '/assets/blog/ganesh-chaturthi-banner.webp',
    link: '/blog/anant-chaturdashi-ganesh-visarjan',
  },
  {
    id: 3,
    title: 'माता वैष्णो देवी की संपूर्ण कथा: भक्त श्रीधर और भैरवनाथ',
    image: '/assets/trending/vaishno-devi.webp',
    link: '/blog/vaishno-devi-story-shridhar-bhairavnath',
  },
];

export default function PitruPakshaBlogDetail() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    document.title =
      'पितृपक्ष में कौए को भोजन क्यों खिलाया जाता है? जानिए पौराणिक कथा और श्राद्ध पूजा विधि | MandirWiki';
  }, [location.pathname]);

  return (
    <div className="blog-detail-page">
      {/* ========================================================
          1. HERO BANNER
      ======================================================== */}
      <section
        className="blog-detail-banner kedarnath-hero-banner"
        style={{
          backgroundImage: "url('/assets/blog/pitru-paksha-crow-banner.jpg')",
          backgroundPosition: 'center center',
        }}
      >
        <Container maxWidth="lg" className="banner-container">
          <Box className="banner-content" sx={{ maxWidth: { xs: '100%', md: '720px' } }}>
            <h1 className="banner-title" style={{ fontSize: 'clamp(24px, 2.7vw, 36px)', lineHeight: 1.35 }}>
              पितृपक्ष में कौए को भोजन क्यों खिलाया जाता है? <br />
              <span style={{ fontSize: '0.85em', fontWeight: 600, opacity: 0.95 }}>
                जानिए पौराणिक कथा और श्राद्ध पूजा विधि
              </span>
            </h1>
          </Box>
        </Container>
      </section>

      {/* ========================================================
          2. MAIN CONTENT & SIDEBAR SECTION
      ======================================================== */}
      <section className="blog-body-section">
        <Container maxWidth="lg">
          <div className="blog-body-inner">
            {/* Breadcrumbs */}
            <nav className="blog-breadcrumbs" aria-label="breadcrumb">
              <Link to="/" className="breadcrumb-link">
                Home
              </Link>
              <span className="breadcrumb-separator">&gt;</span>
              <Link to="/blog" className="breadcrumb-link">
                Blog
              </Link>
              <span className="breadcrumb-separator">&gt;</span>
              <span className="breadcrumb-current">
                पितृपक्ष में कौए को भोजन और श्राद्ध पूजा विधि
              </span>
            </nav>

            {/* Two Column Grid */}
            <div className="blog-main-layout">
              {/* Left Column: Article Body */}
              <article className="blog-article-content">
                <p className="article-paragraph">
                  धार्मिक मान्यताओं में कौए को पितरों से जुड़ा हुआ मानते हैं। इसलिए पितृपक्ष में श्राद्ध का एक अंश कौए को भी खिलाए जाने की परंपरा है।
                </p>

                <h2 className="article-heading">
                  पितृपक्ष में कौए को भोजन खिलाने का महत्व
                </h2>

                <p className="article-paragraph">
                  पितृपक्ष में कौओं का बड़ा ही महत्व है। श्राद्ध पक्ष में कौआ यदि तुम्हारे द्वारा दिया गया भोजन ग्रहण कर ले, तो ऐसा माना जाता है कि पितरों की कृपा तुम्हारे ऊपर है और पितर प्रसन्न हैं। इसके विपरीत यदि कौए भोजन करने नही आए तो यह माना जाता है, कि पितर नाराज हैं। मान्यताओं के अनुसार व्यक्ति मरकर सबसे पहले कौए के रूप में जन्म लेता है, और कौए को खाना खिलाने से वह भोजन पितरों को मिलता है। इसका कारण यह है कि पुराणों में कौए को देवपुत्र माना गया है। कहते हैं कि सबसे पहले देवराज इंद्र के पुत्र जयंत ने कौए का रूप धरा था। जिसके पीछे पुराणों में एक कथा का वर्णन भी मिलता है।
                </p>

                {/* Section: Katha */}
                <h2 className="article-heading">
                  श्राद्ध में कौए को भोजन कराने की पौराणिक कथा
                </h2>

                {/* Inline Media Row: Banner Image + Story Content */}
                <div className="article-media-row">
                  <div className="media-image-box">
                    <img
                      src="/assets/blog/pitru-paksha-crow-banner.jpg"
                      alt="पितृपक्ष में कौए को भोजन और श्राद्ध भोग"
                      className="media-image"
                      loading="lazy"
                    />
                  </div>
                  <div className="media-text-box">
                    <p className="article-paragraph">
                      एक पौराणिक कथा के अनुसार ये बात  त्रेतायुग की है। एक दिन भगवान राम और माता सीता वन में घूम रहे थे। तभी देवराज इंद्र के पुत्र जयंत ने कौए का रूप धारण कर भगवान राम की शक्ति को परखना चाहा, और फिर उसने माता सीता के पैर में चोंच मारकर उनका पैर लहूलुहान कर दिया। माता सीता को अत्यधिक पीड़ा होने लगी।  उनकी पीड़ा को देखकर भगवान राम उस कौए पर क्रोधित हो गए! कौए के रूप में जयंत अपनी जान बचाने के लिए इधर-उधर उड़ने लगा। सबसे पहले जयंत अपने असली रूप को धारण कर अपने पिता इंद्र के पास गया और उनसे सहायता मांगने लगा। किंतु देवराज इंद्र जानते थे कि उनके पुत्र जयंत ने जानबूझकर माता सीता को क्षति पहुंचाई है, और प्रभु श्री राम से बैर लिया है। इसलिए उन्होंने अपने पुत्र को शरण देने से मना कर दिया। अब जयंत भयभीत हो गया।
                    </p>
                  </div>
                </div>

                <p className="article-paragraph">
                  पिता के शरण न देने पर जयंत भयभीत होकर ब्रह्मलोक, शिवलोक सहित सभी लोकों में व्याकुल होकर भागता रहा, सत्य जानने के बाद कोई भी देवता जयंत की सहायता के लिए तैयार नहीं थे। तब देवर्षि नारद ने जयंत को समझाया, कि तुम प्रभु श्री राम के दोषी हो, तुम वापस उनके पास जाओ और उनसे क्षमा मांग लो! वह बहुत दयालु हैं, तुम्हें अवश्य ही क्षमा कर देंगे। नारद मुनि की बात मानकर जयंत भगवान श्री राम की शरण में जाता है, और उनसे क्षमा मांगता है। दयालु प्रभु श्रीराम जयंत को क्षमा कर देते हैं, साथ ही जयंत की प्रार्थना पर उसे आशीर्वाद देते हैं, कि पितृ पक्ष में कौओं को भोजन खिलाने का बहुत महत्व होगा। कौओं को अर्पित किया भोजन पितरों को प्राप्त होगा। तभी से श्राद्ध में कौओं को भोजन कराने की परम्परा चली आ रही है। यही कारण है कि श्राद्ध पक्ष में कौओं को ही पहले भोजन कराया जाता है। श्राद्ध में खीर-पूड़ी आदि पकवान बनाकर कौओं को भोग लगाते हैं।
                </p>

                <h2 className="article-heading">
                  पितृपक्ष में श्राद्ध का महत्व और परिवार को मिलने वाले लाभ
                </h2>

                <p className="article-paragraph">
                  श्राद्ध पक्ष पितरों को प्रसन्न करने का एक उत्सव है। यह वह अवसर होता है जब हम खीर-पूड़ी आदि पकवान बनाकर उस भोग को अपने पितरों को अर्पित करते हैं, जिससे तृप्त होकर पितृ हमें आशीर्वाद देते हैं।
                </p>

                <p className="article-paragraph">
                  पितृ कभी भी अपनी संतानों को परेशान नहीं करना चाहते हैं, वे बहुत दयालु होते हैं। लेकिन संतानों की उपेक्षा से उन्हें दुख होता है। क्योंकि संतान के द्वारा श्राद्धकर्म और पिंडदान आदि करने से उन्हें तृप्ति मिलती है, और वे अपनी संतानों को धन-धान्य और खुश रहने का आशीर्वाद देते हैं। पितृ यह नहीं चाहते कि उनकी संतानें उनको तृप्त करने के लिए बहुत कुछ करें, वे श्रद्धा भाव से किए गए श्राद्ध को खुशी के साथ स्वीकारते हैं।
                </p>

                <p className="article-paragraph">
                  लोक मान्यता के अनुसार, और” पुराणों में भी बताया गया है कि पितृपक्ष के दौरान परलोक गए पूर्वजों को पृथ्वी पर अपने परिवार के लोगों से मिलने का अवसर मिलता है, और वह पिंडदान, अन्न और जल ग्रहण करने की इच्छा से अपनी संतानों के पास रहते हैं।
                </p>

                <div className="blog-full-grid-section">
              <div className="article-full-banner">
                <img
                  src="/assets/blog/pitru-paksha-tarpan-puja.jpg"
                  alt="पितृपक्ष श्राद्ध तर्पण पूजा विधि"
                  className="full-banner-img"
                  loading="lazy"
                />
              </div>

              <div className="full-grid-content">
                <h2 className="article-heading">
                  पितृपक्ष की पूजा विधि
                </h2>

                <p className="article-paragraph">
                  प्रचलित मान्यता के अनुसार पितृपक्ष की पूजा के लिए सुबह उठकर स्नान करें, उसके बाद पूरे घर की सफाई करें। घर में गंगाजल और गौमूत्र भी छिड़कें।
                </p>

                <p className="article-paragraph">
                  दक्षिण दिशा में मुख करके तांबे के चौड़े बर्तन में काले तिल, गाय का कच्चा दूध, गंगाजल और पानी डालें। उस जल को दोनों हाथों में भरकर सीधे हाथ के अंगूठे से उसी बर्तन में गिराएं। इस तरह 11 बार करते हुए पितरों का ध्यान करें।
                </p>

                <p className="article-paragraph">
                  ब्राह्मण को न्यौता देकर बुलाएं। ब्राह्मण को भोजन कराने से पहले गाय, कुत्ते, कौए, देवता और चींटी के लिए भोजन का अंश पत्ते पर निकालें। इसके बाद ब्राह्मण के पैर धोकर उन्हें भोजन कराएं।
                </p>

                <p className="article-paragraph">
                  दक्षिण दिशा की ओर मुख करके  कुश, जौ, तिल, चावल और जल लेकर संकल्प करें और एक या तीन ब्राह्मणों को भोजन कराएं। इसके बाद थाली अथवा पत्ते पर ब्राह्मण के लिए भोजन परोसें। भोजन के उपरांत यथाशक्ति दक्षिणा और अन्य सामग्री दान करें। इसमें गौ, भूमि, तिल, स्वर्ण, घी, वस्त्र, अनाज, गुड़, चांदी तथा नमक (जिसे महादान कहा गया है) का दान करें। इसके बाद निमंत्रित ब्राह्मण की चार बार प्रदक्षिणा कर आशीर्वाद लें।
                </p>

               
               
              </div>
            </div>
              </article>

              {/* Right Column: Sidebar Cards (Sticky) */}
              <aside className="blog-sidebar">
                {/* Card 1: Shradh Muhurat / Timings */}
                <div className="muhurat-widget-card">
                  <div className="muhurat-header">
                    <div className="muhurat-header-title">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="clock-icon"
                      >
                        <circle cx="12" cy="12" r="10" />
                        <polyline points="12 6 12 12 16 14" />
                      </svg>
                      <span>Shradh Muhurat &amp; Tarpan Timings</span>
                    </div>

                    <span className="muhurat-pill-badge">
                      <span className="dot" />
                      Pitru Paksha &bull; Holy Shradh
                    </span>
                  </div>

                  <div className="muhurat-body">
                    <div className="visarjan-day-meta">
                      Auspicious Period: <strong>Aparahna Kaal (Kutup &amp; Rohina Muhurat)</strong>
                    </div>

                    <div className="timings-list">
                      {timingsData.map((item) => (
                        <div
                          key={item.id}
                          className={`timing-row ${item.highlight ? 'highlight-gold' : ''}`}
                        >
                          <span className="timing-label">{item.title}</span>
                          <span className={`timing-val color-${item.timeColor}`}>
                            {item.time}
                          </span>
                        </div>
                      ))}
                    </div>

                    <Link to="/contact-us" style={{ textDecoration: 'none' }}>
                      <button type="button" className="book-puja-btn">
                        BOOK PITRU TARPAN &amp; SHRADH PUJA
                      </button>
                    </Link>

                    <p className="instant-booking-note">
                      Experienced Vedic Pandits for Pind Daan &amp; Tarpan Seva
                    </p>
                  </div>
                </div>

                {/* Card 2: Pitru Paksha Quick Dossier */}
                <div className="sidebar-card dossier-card">
                  <div className="sidebar-card-header">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="header-icon"
                    >
                      <path d="M3 21h18M3 10h18M5 10v11M19 10v11M9 10v11M15 10v11M12 2l10 8H2l10-8z" />
                    </svg>
                    <h3 className="card-title">Pitru Paksha Quick Dossier</h3>
                  </div>

                  <div className="dossier-table">
                    {dossierData.map((row, idx) => (
                      <div key={idx} className="dossier-row">
                        <span className="dossier-key">{row.key}</span>
                        <span className="dossier-val">{row.val}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Card 3: Panchbali Shrines / Offerings */}
                <div className="sidebar-card ghats-card">
                  <div className="sidebar-card-header">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="header-icon"
                    >
                      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                      <polyline points="22 4 12 14.01 9 11.01" />
                    </svg>
                    <h3 className="card-title">Sacred Panchbali Offerings</h3>
                  </div>

                  <div className="ghats-list">
                    {panchbaliList.map((item) => (
                      <div key={item.id} className="ghat-item">
                        <img src={item.image} alt={item.name} className="ghat-thumb" />
                        <div className="ghat-info">
                          <h4 className="ghat-name">{item.name}</h4>
                          <span className="ghat-tag">{item.tag}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Card 4: Free Shradh Vidhi Guide PDF */}
                <div className="sidebar-card pdf-card">
                  <div className="sidebar-card-header">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="header-icon"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <path d="M8 12l4 4 4-4m-4-4v8" />
                    </svg>
                    <h3 className="card-title">Free Offline Shradh Guide (PDF)</h3>
                  </div>

                  <p className="pdf-desc">
                    Comprehensive Vedic handbook covering Tarpan mantras, Pind Daan rituals, Panchbali offerings, and Brahman Bhojan rules.
                  </p>

                  <a
                    href="/assets/startup-india-certificate.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none' }}
                  >
                    <button type="button" className="download-pdf-btn">
                      DOWNLOAD SHRADH GUIDE (PDF)
                    </button>
                  </a>
                </div>
              </aside>
            </div>

            {/* ========================================================
                3. FULL GRID SECTION (Full Container Width Content)
            ======================================================== */}
            <div className="blog-full-grid-section">
             

              <div className="full-grid-content">
               

                <h2 className="article-heading">
                  पितृपक्ष में श्राद्ध से परिवार को मिलता है पितरों का आशीर्वाद
                </h2>

                <p className="article-paragraph">
                  पितृपक्ष में मिले अन्न और जल से पितरों को बल मिलता है। इसी से वे परलोक की अपनी यात्रा पूरी कर पाते हैं। इन्हीं अन्न जल की शक्ति से वे अपने परिवार के सदस्यों का कल्याण करते हैं।
                </p>

                <p className="article-paragraph">
                  कहा भी गया है कि श्रद्धा के बिना श्राद्ध अधूरा है। इसलिए अपने पितरों का श्राद्ध पूरी श्रद्धा और सेवा भावना से करना चाहिए ताकि पितरों का आशीर्वाद सदैव अपने परिवार पर बना रहे।
                </p>
              </div>
            </div>
          </div>
        </Container>
      </section>

      {/* ========================================================
          4. YOU MIGHT ALSO BE INTERESTED IN THIS
      ======================================================== */}
      <section className="blog-interested-section pt-0">
        <Container maxWidth="lg">
          <h2 className="interested-heading">
            You Might Also Be Interested In This
          </h2>
          <div className="interested-grid">
            {interestedBlogs.map((item) => (
              <Link
                key={item.id}
                to={item.link}
                className="interested-card"
              >
                <div className="card-thumb-wrap">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="card-thumb"
                    loading="lazy"
                  />
                </div>
                <div className="card-content">
                  <h3 className="card-title">{item.title}</h3>
                </div>
              </Link>
            ))}
          </div>
        </Container>
      </section>
    </div>
  );
}
